<template>
  <div class="wrap">
    <div class="ai_wrap">
        <div class="ai_h">
            <img src="https://cdncos.aigupiao.com/assets/pc/img/2023/AI.png" alt="">
            <span>爱股票AI</span>
            <i>{{ time }}</i>
        </div>
        <div class="ai_c" v-html="content_wrap">
        </div>
        <div class="ai_q">{{ title }}</div>

        <div class="ai_app">
            <div class="ai_app_l">
                <h1>长按二维码</h1>
                <h2>爱股票AI，最懂投资的专属AI</h2>
            </div>
            <img src="https://cdncos.aigupiao.com/assets/pc/img/qrcode.png" alt="">
        </div>

    </div>
    <div class="app_wrap">
        <img src="https://cdncos.aigupiao.com/assets/pc/img/2023/aiapp.png" alt="">
        <div class="app_word">
            <h1>爱股票 APP</h1>
            <h2>专 业 投 资 者 社 区</h2>
        </div>
    </div>
  </div>
</template>

<script>
import "@/utils/flexible";
export default {
    data(){
        return{
            content:``,
            title:'',
            time:``,
            id:this.$route.params.id,
            }

    },
    computed:{
        content_wrap(){
            return this.content.replace(/\n/gi,'<br />');
        },
        CURRENT_ENV_PRE(){
            let host0 = window.location.href;
            if(host0.indexOf("8081") > 0) return "dev";//vue项目 本地调试设置变量
            if (host0.indexOf("dev") > 0) return "dev";
            if (host0.indexOf("beta") > 0) return "beta";
            return '';
        }
    },
    created(){
        this.init();
    },
    methods:{
        init(){
            //https://appdev.aigupiao.com/goapi/ai/share?id=1
            let _this = this;
            $.ajax({
                xhrFields: { withCredentials: true },
                type: "get",
                url: `https://app${this.CURRENT_ENV_PRE}.aigupiao.com/goapi/ai/share?id=${this.id}`,
                cache: false,
                async: true,
                error: function () {
                    return false;
                },
                success: function (data) {
                    console.log(data);
                    let share = data.data.share;
                    _this.content = share.answer;
                    _this.title = `“${share.question}”`;
                    _this.time = new Date(share.q_time * 1000).toLocaleString().substring(5,16).replace('/','-') ;
                },
            })
        }
    },
}

</script>
<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";
.wrap{
    padding: rem2(20px) rem2(20px);
    background: linear-gradient(180deg, #FF1B42 0.01%, #EA414B 99.99%);


    .ai_wrap{
        border-radius: 8px;
        background: #FFF;
        padding: rem2(15px) rem2(15px) rem2(20px);
        margin-bottom: rem2(20px);

        .ai_h{
            display: flex;
            align-items: center;
            >img{
                width: rem2(28px);
                height: rem2(28px);
            }
            >span{
                color: #333;
                font-size: rem2(15px);
                font-weight: 500;
                margin: 0 rem2(10px);
            }
            >i{
                color: #A0A0A0;
                font-size: rem2(14px);
                font-style: normal;
            }
        }
        .ai_c{
            margin: rem2(15px) 0;

            padding: rem2(10px);
            min-height: 50vh;
            border-radius: rem2(8px);
            background: #F6F7FA;

            color: #282828;
            font-size: rem2(15px);
            line-height: 180%; /* 27px */
        }
        .ai_q{
            margin-left: rem2(10px);
            color: #333;
            font-size: rem2(17px);
            font-weight: 500;
            line-height: 150%; /* 25.5px */
        }

        .ai_app{
            border-top: rem2(1px) solid #EBEBEB;
            display: flex;
            align-items: center;
            padding-top: rem2(20px);
            margin-top: rem2(20px);
            justify-content: space-between;
            >img{
                width: rem2(50px);;
            }

            h1{
                color: #333;

                font-size: rem2(16px);

                line-height: 150%; /* 24px */
            }
            h2{
                color: rgba(51, 51, 51, 0.70);

                font-size: rem2(13px);


                line-height: 150%; /* 19.5px */
            }
        }
    }

    .app_wrap{
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFF;
        >img{
            width: rem2(45px);
            height: rem2(45px);
            margin-right: rem2(10px);
        }


        h1{
            font-size: rem2(20px);
            font-weight: 600;
            margin-bottom: rem2(5px);
        }

        h2{
            font-size: rem2(12px);
            font-weight: 500;
        }

    }


}
</style>